import { MarketOverviewWithNews } from '@toggle/toggle';

import { create } from '~/utils/store/createStore';

type MarketInsightsStore = {
  setSelectedMarketInsight: (marketInsight?: MarketOverviewWithNews) => void;
  marketOverviewInsightGroupedByDate: Record<string, MarketOverviewWithNews[]>;
  setMarketOverviewInsightGroupedByDate: (
    marketOverviewInsightGroupedByDate: Record<string, MarketOverviewWithNews[]>
  ) => void;
  getActiveMarketInsightsGroup: (
    date: string
  ) => MarketOverviewWithNews[] | undefined;
  /**
   * @deprecated
   */
  selectedMarketInsight?: MarketOverviewWithNews;
};

export const useMarketInsightsStore = create<MarketInsightsStore>(
  (set, get) => ({
    marketOverviewInsightGroupedByDate: {},
    setMarketOverviewInsightGroupedByDate: marketOverviewInsightGroupedByDate =>
      set({ marketOverviewInsightGroupedByDate }),
    getActiveMarketInsightsGroup: date => {
      const state = get();
      const day = date.split('T')[0];
      return state.marketOverviewInsightGroupedByDate[day];
    },
    /**
     * @deprecated
     */
    setSelectedMarketInsight: (marketInsight?: MarketOverviewWithNews) =>
      set({ selectedMarketInsight: marketInsight }),
  })
);
